// extracted by mini-css-extract-plugin
module.exports = {"item":"style_item__19nNS","itemLink":"style_itemLink__3ZEJr","itemPic":"style_itemPic__1yopv","itemIcon":"style_itemIcon__344u4"};